<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qftQYB/tc-custom/9781401689049.jpg?1725275784057" alt="This image is the cover for the book Still Life"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Still Life
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Ada escaped her family’s self-enclosed world to elope with a mysterious stranger. Five months later, she’s a widow in a strange new world.</b></p><p>Ada was born into a fringe religious sect named for her father, The Prophet. But her lifelong habit of absolute obedience was shattered when she fled the family compound to elope with photographer Julian Goetz.</p><p>Katherine Walker’s marriage was a sham. She and Will rarely spoke without yelling—and never touched. Her affair brings her both escape and guilt.</p><p>When a tragic plane crash takes Julian from Ada and exacerbates Katherine’s sense of shame, both women become desperately unsure of where they belong in the world—until the devotion of an artistic young boy conspires to bring them together.</p><p>From award-winning novelist Christa Parrish, <i>Still Life </i>is a cunningly complex work that captures themes of abusive religion, supernatural love, and merciful escape. It will resonate with anyone who has ever felt called to a drastic change—or tried to hear the small whisper of God’s voice.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Christa Parrish
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Nelson
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?481d52e0